/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {SpoDetailPageHeaderComponent} from './spo-detail-page-header/spo-detail-page-header.component';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {SingleMaterialStatusModule} from '../../shared/single-material-status/single-material-status.module';
import {NgbDropdownModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {TooltipModule} from '../../shared/tooltip/tooltip.module';

@NgModule({
    declarations: [
        SpoDetailPageHeaderComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        NgbDropdownModule,
        SingleMaterialStatusModule,
        TooltipModule,
        NgbTooltipModule
    ],
    exports: [SpoDetailPageHeaderComponent]
})

export class SpoSharedModule {
}
